// @flow
import React from 'react';
import GeolocationButton from './GeolocationButton';

const onFocus = event => {
  event.target.setSelectionRange(0, event.target.value.length);
};

const onMouseUp = event => {
  event.preventDefault();
};

type Props = {
  value?: string,
  onChange: (...args: Array<any>) => any,
  onKeyDown: (...args: Array<any>) => any,
  onBlur: (...args: Array<any>) => any,
  placeholder?: string,
  onAddressFound: (...args: Array<any>) => any,
  showGeoLocation?: boolean,
  label: string | boolean
};

const SearchComponentInput = ({
  onChange,
  onKeyDown,
  onBlur,
  onAddressFound,
  label,
  value = '',
  placeholder = 'Where would you like to park?',
  showGeoLocation = true
}: Props) => {
  return (
    <div className="c-predictive-search-input__input-container">
      {label && (
        <span className="c-predictive-search-input__span">{label}</span>
      )}
      <input
        type="text"
        id="search-box"
        name="q"
        className="form-control c-focus-geolocation__input"
        placeholder={placeholder}
        autoComplete="off"
        spellCheck="false"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onMouseUp={onMouseUp}
        onBlur={onBlur}
      />
      {showGeoLocation && <GeolocationButton onAddressFound={onAddressFound} />}
    </div>
  );
};

export default SearchComponentInput;
